// eslint-disable-next-line import/prefer-default-export
export const AUTHORIZED_BROWSERS = ['FIREFOX', 'CHROME', 'SAFARI'];



// WEBPACK FOOTER //
// ./src/configuration/browserConf.js